import React from "react";
import { Card, KeyValueList } from "@sscs/ui";
import { formatDistanceToNow } from "date-fns";
const PolicyAudit = ({ audit, title = "Audit information", nested = false, className, }) => {
    if (!audit.present)
        return null;
    const list = {
        Reason: audit.reason,
        Author: audit.author,
        Time: formatDistanceToNow(new Date(audit.timestamp), {
            addSuffix: true,
        }),
    };
    if (nested) {
        return React.createElement(KeyValueList, { list: [title, list], className: className });
    }
    return (React.createElement(Card.Card, { className: className },
        React.createElement(Card.Title, null, title),
        React.createElement(Card.Content, null,
            React.createElement(KeyValueList, { list: list }))));
};
export default PolicyAudit;
//# sourceMappingURL=PolicyAudit.js.map